import React from "react";
import { FieldError } from "react-hook-form";

interface FormRowProps {
  label: string;
  children: React.ReactNode;
  required?: boolean;
  error?: FieldError;
  className?: string;
}

export const FormRow: React.FC<FormRowProps> = ({
  label,
  children,
  required = false,
  error,
  className = "",
}) => {
  return (
    <div className={`formField formRow ${className}`}>
      {label && (
        <label>
          {label}
          {required && <span className="requireSymbol">*</span>}
        </label>
      )}
      {children}
      {error && <p className="errorText">{error.message}</p>}
    </div>
  );
};
